import { DataSchema } from "common";
import { selectAtom } from "jotai/utils";
import { authAtom } from "./auth";
import {
  toSearchFormFilters,
  toSearchFormLanguagesFilter,
  toSearchFormModelGroupsFilter,
} from "@/pages/Search/search-form-model";

export type ModelGroups = DataSchema.AuthUser["modelGroups"];
export type Languages = DataSchema.AuthUser["languages"];
export type Categories = DataSchema.AuthUser["categories"];

export const searchFormFiltersAtoms = selectAtom(authAtom, (auth) => {
  if (auth.type === "LoggedIn") {
    return toSearchFormFilters({
      modelGroups: auth.user.modelGroups,
      languages: auth.user.languages,
      categories: auth.user.categories,
    });
  }
  return {
    filterModelGroups: toSearchFormModelGroupsFilter([]),
    filterLanguages: toSearchFormLanguagesFilter([]),
    filterCategories: [],
  };
});

export const categoryLabelsAtoms = selectAtom(authAtom, (auth) => {
  const categories = auth.type === "LoggedIn" ? auth.user.categories : [];
  const items: Record<string, string> = {};
  categories.forEach((value) => {
    items[value.code] = value.name;
  });
  return items;
});
